// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearLocation = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.99992 8.95334C9.14867 8.95334 10.0799 8.02209 10.0799 6.87334C10.0799 5.72458 9.14867 4.79333 7.99992 4.79333C6.85117 4.79333 5.91992 5.72458 5.91992 6.87334C5.91992 8.02209 6.85117 8.95334 7.99992 8.95334Z',
      stroke: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.41281 5.66004C3.72615 -0.113291 12.2795 -0.106624 13.5861 5.66671C14.3528 9.05338 12.2461 11.92 10.3995 13.6934C9.05948 14.9867 6.93948 14.9867 5.59281 13.6934C3.75281 11.92 1.64615 9.04671 2.41281 5.66004Z',
      stroke: 'currentColor',
    }),
  );

export { IconLinearLocation };
